export default "__VITE_ASSET__BlmzTuc6__"